import { useQueryClient } from "@tanstack/react-query";

// Every timeline on screen reads again (ra-core query keys start with the
// resource name)
export const useRefreshTimeline = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["tenax_timeline"] });
};
